exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.support-float-btn[data-v-2d51ca69] {\n  position: fixed;\n  right: 2.5rem;\n  bottom: 1rem;\n  z-index: 9999;\n  padding: .14rem .22rem;\n  border: none;\n  border-radius: .1rem;\n  color: #fff;\n  font-size: .18rem;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, .12);\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n.support-float-btn[data-v-2d51ca69] {\n    right: .24rem;\n    bottom: .24rem;\n    font-size: .25rem;\n    padding: .2rem .5rem;\n    border-radius: .22rem;\n}\n}\n", ""]);

// exports
